var shimmer = tokens => ({
  base: {
    time: '3.0s'
  },
  variants: {
    light: {
      color: tokens.colors.neutral['20']
    },
    dark: {
      color: tokens.colors.neutral['90']
    }
  }
});
export default shimmer;
//# sourceMappingURL=shimmer.js.map